<template>
  <div>
    <img class="poster" :src="lite" />
    <div class="main">
      <div class="divide">
        <div class="line"></div>
        <div class="content">项目收获</div>
      </div>
      <div class="got">
        <div v-for="item in got" :key="item[0]">
          <img src="./img/gou-lite.png" />
          {{ item[0] }}
          <span v-if="item[1] === 1" class="small">可用于申请</span>
          <span v-if="item[1] === 2">（选看）</span>
        </div>
      </div>
      <div class="divide">
        <div class="line"></div>
        <div class="content">适合人群</div>
      </div>
      <div class="people">
        <div class="content">
          有意提高自身知识水平及学术能力的学生；有意掌握最前沿科研热点及科研方法的学生；有升学意向、跨专业深造的学生。
        </div>
        <div>
          <p>适合年级：{{ get_degree() }}</p>
          <p>
            适合专业：
            <span v-for="item in tags" :key="item" class="tag">
              {{ item }}
            </span>
          </p>
          <p>项目会涉及到{{ method }}。学生需要具备{{ ability }}。</p>
        </div>
      </div>
      <div class="divide">
        <div class="line"></div>
        <div class="content">项目特色</div>
      </div>
      <div class="people">
        <p>高效1V1：因材施教，大幅节约时间</p>
        <p>独一无二：拒绝班课及模板推荐，让推荐信真正具有意义</p>
        <p>直达标准：审稿人亲自辅导，一次达标，不走弯路</p>
      </div>
      <div class="divide">
        <div class="line"></div>
        <div class="content">导师介绍</div>
      </div>
      <div class="teacher">
        <p>推荐信身份：{{ identity }}</p>
        <p>EI/CPCI国际学术会议委员会成员</p>
        <div class="content">
          {{ paper }}
        </div>
      </div>
      <div class="divide">
        <div class="line"></div>
        <div class="content">项目背景</div>
      </div>
      <div class="back">
        {{ back }}
      </div>
      <div class="divide">
        <div class="line"></div>
        <div class="content">项目简介</div>
      </div>
      <div class="introduce">
        {{ introduce }}
      </div>
      <div class="divide">
        <div class="line"></div>
        <div class="content">参考学习内容</div>
      </div>
      <div class="refer">
        <div class="task">
          <div class="left">
            <div class="circle"></div>
            <div class="line"></div>
          </div>
          <div style="color:#5BB680;">任务一：掌握查阅文献和研究方法</div>
          <p>掌握查阅文献和面向文献学习的方法;</p>
          <p>掌握文献管理的方法；</p>
          <p>通过查阅文献，学习该方向的研究热点和方向；</p>
          <p>掌握快速提炼文献重要信息的方法。</p>
        </div>
        <div v-for="(item, index) in task" :key="item.title" class="task">
          <div class="left">
            <div class="circle"></div>
            <div class="line"></div>
          </div>
          <div style="color:#5BB680;">{{ taskt[index] }}：{{ item[0] }}</div>
          <p v-for="value in itemsplit(item)" :key="value">{{ value }}</p>
        </div>
        <div class="task">
          <div class="left">
            <div class="circle"></div>
          </div>
          <div style="color:#5BB680;">任务六：项目收尾</div>
          <p>撰写整体报告；</p>
          <p>准备一次20~30分钟的presentation。（可选）</p>
        </div>
      </div>
      <div class="tips">（以上任务仅供参考，实际辅导根据定制化要求展开）</div>
      <div class="files">
        附件
        <div class="fileList">
          <img src="./img/suo-lite.png" class="suo" />
          <div class="file" v-for="item in files" :key="item" @click="download(item)">
            <img class="pdf" src="./img/pdf-lite.png" />
            {{ item }}
            <img class="down" src="./img/down-lite.png" />
          </div>
        </div>
      </div>
      <div class="tips">
        （注：补充包所涉及课程，旨在为参与项目的学生强化学术基础，将与1v1正式科研穿插进行，当补充包课程与1v1核心专业指导时间冲突时，以1v1的指导安排为主。
        补充课程的具体安排安排及内容详情参考附件。）
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../axios'
export default {
  data() {
    return {
      got: [
        ['专属科研推荐信', 1],
        ['科研报告', 0],
        ['5周在线一对一科研学习', 0],
        ['定制化学术研究经历', 0],
        ['63课时科研基础课', 2]
      ],
      tags: [],
      task: [],
      files: [
        '项目流程详情-Lite',
        '导师简历',
        '专属科研推荐信范例',
        '学员案例-Lite',
        'FAQ-Lite',
        '63学时科研基础课详情'
      ],
      uuid: '',
      title: '',
      direction_tag: '',
      degree: '',
      method: '',
      ability: '',
      identity: '',
      paper: '',
      back: '',
      introduce: '',
      taskt: ['任务二', '任务三', '任务四', '任务五'],
      lite: '',
      resume: ''
    }
  },
  created() {
    let path = this.$route.path
    let uuid = path.split('/').pop()
    axios
      .get('previews/get_lsp', {
        params: {
          uuid: uuid,
          type: 'lite'
        }
      })
      .then(res => {
        Object.assign(this.$data, res.data)
        document.title = this.title
      })
  },
  mounted() {
    let x = document.body.clientWidth
    document.documentElement.style.fontSize = x / 15 + 'px'
    window.onresize = () => {
      return (() => {
        let x = document.body.clientWidth
        document.documentElement.style.fontSize = x / 15 + 'px'
      })()
    }
  },
  methods: {
    itemsplit(item) {
      item = item.slice(1)
      item = item.map((e, index) => {
        if (index < item.length - 1) {
          e += '；'
        } else e += '。'
        return e
      })
      return item
    },
    get_degree() {
      switch (this.degree) {
        case '5':
          return '研究生'
        case '4':
          return '本科生/研究生'
        default:
          return '高中生/本科生/研究生'
      }
    },
    download(item) {
      item = item.replace('/', '_')
      let url = `https://elitebackground.oss-cn-zhangjiakou.aliyuncs.com/poster/Lite/${item}.pdf`
      if (item === '导师简历') {
        url = this.resume
      }
      let routeData = this.$router.resolve({
        path: '/pdf3',
        query: {
          url: url
        }
      })
      if (/Android|webOS|iPhone|ipad/i.test(navigator.userAgent)) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(url, '_blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  padding: 0 20rem * 0.04;
  padding-bottom: 90rem * 0.04;
}

.poster {
  width: 375rem * 0.04;
  height: 210rem * 0.04;
}

.title {
  margin-top: 30rem * 0.04;
  font-family: PFBD;
  font-style: normal;
  font-weight: 600;
  font-size: 16rem * 0.04;
  line-height: 24rem * 0.04;
  text-align: justify;
  color: #555555;
}

.divide {
  font-family: PFBD;
  font-style: normal;
  font-weight: 600;
  font-size: 12rem * 0.04;
  line-height: 16rem * 0.04;
  margin-top: 30rem * 0.04;
  margin-bottom: 10rem * 0.04;
  color: #5bb680;
  height: 14rem * 0.04;
  position: relative;

  .line {
    top: 7rem * 0.04;
    border-top: 1rem * 0.04 solid #5bb680;
    position: absolute;
    width: 100%;
  }

  .content {
    margin-left: 10rem * 0.04;
    background: #fff;
    padding: 0 10rem * 0.04;
    position: absolute;
    font-family: PFBD;
    font-style: normal;
    font-weight: 600;
    font-size: 12rem * 0.04;
    line-height: 16rem * 0.04;
    color: #5bb680;
  }
}

.got {
  font-family: PFBD;
  font-style: normal;
  font-weight: 400;
  font-size: 12rem * 0.04;
  line-height: 20rem * 0.04;

  .small {
    color: #5bb680;
    font-size: 10rem * 0.04;
  }

  img {
    margin-right: 5rem * 0.04;
    width: 9.74rem * 0.04;
  }
}

.people {
  font-family: PFBD;
  font-style: normal;
  font-weight: 400;
  font-size: 12rem * 0.04;
  line-height: 20rem * 0.04;
  color: #000000;

  .content {
    margin-bottom: 5rem * 0.04;
  }

  .tag {
    height: 18rem * 0.04;
    padding: 0 5rem * 0.04;
    line-height: 18rem * 0.04;
    background: #5bb680;
    margin-right: 10rem * 0.04;
    display: inline-block;
    color: #fff;
  }
}

p {
  display: list-item;
  position: relative;
  left: 2em;
  width: calc(100% - 2em);
  line-height: 20rem * 0.04;
}

.teacher {
  font-family: PFBD;
  font-style: normal;
  font-weight: 400;
  font-size: 12rem * 0.04;
  line-height: 20rem * 0.04;
  text-align: justify;
  color: #000000;
  white-space: pre-line;

  .content {
    margin-top: 5rem * 0.04;
  }
}

.back {
  font-family: PFBD;
  font-style: normal;
  font-weight: 400;
  font-size: 10rem * 0.04;
  line-height: 16rem * 0.04;
  text-align: justify;
  color: #000000;
  white-space: pre-line;
}

.introduce {
  font-family: PFBD;
  font-style: normal;
  font-weight: 400;
  font-size: 10rem * 0.04;
  line-height: 16rem * 0.04;
  text-align: justify;
  color: #000000;
  white-space: pre-line;
}

.refer {
  font-family: PFBD;
  font-style: normal;
  font-weight: 500;
  font-size: 10rem * 0.04;
  line-height: 16rem * 0.04;
  color: #000000;

  p {
    line-height: 14rem * 0.04;
    font-weight: 400;
  }

  .task {
    padding-left: 18rem * 0.04;
    position: relative;
    padding-bottom: 15rem * 0.04;
  }

  .left {
    position: absolute;
    left: 0;
    top: 0.5em;
    height: 100%;
  }

  .circle {
    height: 5rem * 0.04;
    width: 5rem * 0.04;
    border-radius: 50%;
    background: #ffffff;
    border: 1rem * 0.04 solid #5bb680;
    box-sizing: border-box;
  }

  .line {
    border-left: 1rem * 0.04 solid #5bb680;
    height: 100%;
    width: 0;
    position: absolute;
    left: 2rem * 0.04;
  }
}

.tips {
  font-family: PFBD;
  font-style: normal;
  font-weight: 400;
  font-size: 12rem * 0.04;
  line-height: 16rem * 0.04;
  text-align: center;
  color: #a7a7a7;
}

.files {
  font-family: PFBD;
  font-style: normal;
  font-weight: 600;
  font-size: 12rem * 0.04;
  line-height: 16rem * 0.04;
  color: #5bb680;
  margin-top: 30rem * 0.04;
  margin-bottom: 10rem * 0.04;

  .fileList {
    border: 1rem * 0.04 solid #5bb680;
    margin-top: 14.5rem * 0.04;
    padding: 10.5rem * 0.04 19.5rem * 0.04 21rem * 0.04;
    position: relative;

    .suo {
      position: absolute;
      top: -4rem * 0.04;
      left: 45rem * 0.04;
      padding: 0 5rem * 0.04;
      width: 15rem * 0.04;
      background: #fff;
    }

    .file {
      background: #ffffff;
      box-shadow: 0rem * 0.04 0rem * 0.04 10rem * 0.04 rgba(0, 0, 0, 0.25);
      padding: 14rem * 0.04 30rem * 0.04 15rem * 0.04 32rem * 0.04;
      margin-top: 11rem * 0.04;
      font-family: PFBD;
      font-style: normal;
      font-weight: 400;
      font-size: 10rem * 0.04;
      line-height: 14rem * 0.04;
      color: #000000;
      position: relative;

      .pdf {
        width: 20rem * 0.04;
        position: absolute;
        left: 8rem * 0.04;
        top: 11rem * 0.04;
      }

      .down {
        width: 15rem * 0.04;
        position: absolute;
        top: 14rem * 0.04;
        right: 10rem * 0.04;
      }
    }
  }
}</style>
